export default {
  "about": {
    "careersDetails": {
      "anqing": "安庆",
      "applyResume": "投递简历",
      "backToPrevious": "返回上一页",
      "category": "类别:",
      "education": "最低学历:",
      "errors": {
        "getInfoFailed": "获取信息失败",
        "getJobDetailFailed": "获取职位详情失败",
        "getJobDetailFailedRetry": "获取职位详情失败，请稍后重试",
        "jobNotExist": "职位信息不存在",
        "parseInfoFailed": "解析信息失败"
      },
      "jobDescription": "职位描述",
      "jobRequirements": "任职要求",
      "nationwide": "全国",
      "noJobInfo": "职位信息不存在",
      "person": "人",
      "recruitmentCount": "招聘人数:",
      "salary": "薪资待遇:",
      "suzhou": "苏州",
      "workLocation": "工作地点:",
      "workYear": "工作年限:"
    },
    "contact": {
      "address": "地址：",
      "contactInfo": "联系方式",
      "email": "邮箱：",
      "errors": {
        "getContactFailed": "获取联系方式数据失败"
      },
      "pageTitle": "联系我们",
      "phone": "电话：",
      "postcode": "邮编："
    },
    "page": {
      "careers": {
        "activities": {
          "balance": {
            "description": "提倡工作和生活平衡",
            "subtitle": "KEEP BALANCED",
            "title": "平衡致远"
          },
          "learning": {
            "description": "打造学习型组织，推动终身学习",
            "subtitle": "KEEP LEARNING",
            "title": "学无止境"
          }
        },
        "category": "类别:",
        "errors": {
          "getAreaFailed": "获取工作地点失败",
          "getAreaFailedRetry": "获取工作地点失败，请稍后重试",
          "getCategoryFailed": "获取职位类别失败",
          "getCategoryFailedRetry": "获取职位类别失败，请稍后重试",
          "getJobsFailed": "获取职位列表失败",
          "getJobsFailedRetry": "获取职位列表失败，请稍后重试",
          "getNatureFailed": "获取工作性质失败",
          "getNatureFailedRetry": "获取工作性质失败，请稍后重试"
        },
        "jobCategory": "职位类别",
        "jobNature": "工作性质",
        "nationwide": "全国",
        "noData": "暂无数据",
        "noJobs": "暂无相关职位",
        "publishDate": "发布",
        "searchBox": {
          "campusRecruitment": "校园招聘",
          "placeholder": "请输入关键字",
          "search": "查询",
          "socialRecruitment": "社会招聘"
        },
        "viewDetail": "查看详情>",
        "workLocation": "工作地点"
      },
      "company": {
        "companyIntro": "亚科股份创立于2003年，总部位于中国苏州。经过多年的创新发展，现已形成集研发、生产、销售和服务于一体的国家高新技术企业。业务范围覆盖生命科学、个人护理、新材料、科研甄选、检测等。",
        "companyName": "亚科股份",
        "dataSection": {
          "founded": "成立",
          "globalCustomers": "全球客户",
          "globalPartners": "全球生态伙伴",
          "patents": "国内外申请专利",
          "productionBase": "年生产能力",
          "salesCountries": "销售国家和地区",
          "title": "企业数据",
          "unit": "吨",
          "year": "年"
        },
        "history": {
          "title": "发展历程"
        },
        "honor": {
          "title": "荣誉资质"
        },
        "pageTitle": "公司介绍",
        "subtitle": "亚科股份，全球医化材料的创新引领者。",
        "vision": {
          "mission": {
            "description": "致力于推动医化材料的技术进步与革新",
            "title": "使命"
          },
          "title": "企业理念",
          "values": {
            "description": "诚信感恩、责任敬勤、务实拼搏、创新卓越",
            "title": "核心价值观"
          },
          "vision": {
            "description": "成为全球医化材料的创新引领者",
            "title": "愿景"
          }
        }
      },
      "production": {
        "intro": "亚科股份具备稳定可靠的制造能力。目前，已建成济宁、安庆两个生产基地，配备国际领先的生产设备与生产工艺，专注于高品质精细化学品的研发与生产。单基地总产能均超过10万吨，并已通过了ISO9001质量管理体系、ISO14001环境管理体系和ISO45001职业健康安全管理体系认证。",
        "intro2": '亚科股份以"零缺陷"质量管控体系确保每一批产品均达到行业高标准，持续为全球客户提供稳定可靠的化学品供应解决方案。基于规模化产能、智能化生产、全道条原料控制的竞争优势，为医疗健康、生物技术等战略新兴产业提供"从科学研究到商业化生产"的一站式原料解决方案，助力客户实现稳健发展。',
        "siteInfo": {
          "area": "占地规模：",
          "capacity": "车间与产能：",
          "coreProducts": "核心产品：",
          "field": "应用领域："
        },
        "title": "生产基地"
      },
      "quality": {
        "equipment": {
          "description": "通过搭建完善的检测仪器平台，涵盖高效液相色谱仪、气相色谱仪、核磁共振谱仪、旋光测定仪、红外光谱仪、电感耦合等离子体发射光谱仪、自动电位滴定仪、卡式库仑法水分仪等，亚科股份能够满足客户在各种影响场景下的高精度、高复杂度的放行检测需求。",
          "devices": {
            "automaticTitrator": "自动电位滴定仪",
            "broadbandNMR": "宽带多线圈核磁共振谱仪",
            "gcms": "GC-MS",
            "icpSpectrometer": "电感耦合等离子体发射光谱仪",
            "infraredSpectrometer": "红外光谱仪",
            "karlFischer": "卡式库仑法水分仪"
          },
          "title": "检测设备"
        },
        "intro": "亚科股份以过程控制保证产品质量，专注于为客户提供更高性价比的多样化产品和更优质的服务，以服务客户创新为己任。基于亚科股份在医化材料领域22年的检测经验沉淀，数名博士领衔的科研分析团队，为客户提供从检测到技术优化的一站式解决方案。",
        "intro2": "亚科股份旗下检测平台拥有3000㎡现代化实验室，已建成国内领先的空气循环与净化系统，确保检测环境安全可控。平台配备了完善的化学分析空间及全套高端仪器，满足高精度、高复杂度的检测需求。依据各国/地区法律法规及技术规范（如欧盟REACH、美国FDA、中国CDE等），协助客户规避贸易壁垒，实现产品全生命周期合规管理。",
        "navigation": {
          "next": "下一个",
          "prev": "上一个"
        },
        "system": {
          "description": "亚科股份已建立了涵盖结构表征、理化性能、元素分析、图谱分析、稳定性研究、数据完整可追溯、杂质分析研究、原辅料检测等全面完善的医化材料检测体系，质量管理通过GMP体系、ISO9001:2015质量管理体系认证，支持客户在全球市场的开发应用。",
          "title": "检测体系"
        },
        "title": "质量管理"
      }
    },
    "tabs": {
      "careers": "加入我们",
      "company": "公司简介",
      "production": "生产基地",
      "quality": "质量管理"
    }
  },
  "dzhc": {
    "businessIntroText": "定制化服务是亚科股份的核心业务。基于医化材料领域22年的研发经验沉淀，亚科股份能够为客户提供可靠稳定的一站式定制化服务。我们拥有一支由资深科学家和工程师组成的研发团队和质检团队，搭建了AI智能合成平台、化学合成平台、生物合成平台等五大实验平台，并配备有高效液相色谱仪、气相色谱仪、旋光测定仪等先进检测平台。此外，亚科股份拥有2个年产能超过十万吨的生产基地，能够满足医化材料领域客户从定制合成，CRO服务到CDMO服务的全流程需求。",
    "businessIntroTitle": "业务概况",
    "businessItems": ['高分子材料', '聚合物单体' , '医药中间体' , '电子化学新材料' , '临床检测原料'],
    "caseTabs": [{"title":"医化领域专家团队","description":"近百位资深科学家和工程师组成，硕博专业人才超过40%，申请研发专利超过150件，已获批超50件。"},{"title":"一流的研发和检测平台","description":"搭建了AI智能合成平台、化学合成平台、生物合成平台等五大实验平台，并配备有高效液相色谱仪、气相色谱仪、旋光测定仪等先进检测平台。"},{"title":"国际质量体系保障","description":"严格遵循ISO国际标准，全流程质量控制，确保产品高可靠性。从原料筛选到成品，多层级检测节点，全流程质量控制。"}],
    "coreBusinessTitle": "核心业务",
    "featureTitle": "服务特色",
    "pageSubtitle": "医化产品CRO+CDMO定制服务",
    "pageTitle": "定制化服务",
    "processItems": [{"title":"线路设计","desc":['100+经验丰富的研发人员','AI辅助合成路线设计']},{"title":"研发合成","desc":['10000+㎡研发实验室','覆盖80%的常用反应']},{"title":"试样生产","desc":['200,000+㎡工厂生产','严格质控，品质保障']},{"title":"分装寄送","desc":['满足各种固体/液体分装发货要求','专业的样品寄送/物流跟踪']}],
    "processTitle": "定制合成流程",
    "startProject": "立即开启您的定制项目",
    "startProjectDesc": "提出您的需求，专业团队为您提供一对一技术咨询与定制化解决方案。",
    "viewMore": "查看更多"
  },
  "header": {
    "contactUs": "联系我们",
    "menu": {
      "about": "关于亚科",
      "companyProfile": "公司简介",
      "customSynthesis": "定制化服务",
      "greenEnergy": "绿色能源",
      "innovation": "创新成果",
      "joinUs": "加入我们",
      "news": "资讯中心",
      "other": "其他业务",
      "production": "生产基地",
      "products": "产品中心",
      "quality": "质量管理",
      "rAndDSystem": "研发体系",
      "researchPurchase": "科研采购",
      "smartPlatform": "智能化平台",
      "solution": "行业解决方案",
      "sustainability": "可持续发展",
      "technology": "研发创新",
      "testingService": "检测服务"
    },
    "searchPlaceholder": "请输入搜索内容..."
  },
  "home": {
    "about": {
      "description": "亚科股份创立于2003年，总部位于中国苏州。经过多年的创新发展，现已形成集研发、生产、销售和服务于一体的国家高新技术企业。业务范围覆盖生命科学、个人护理、新材料、科研甄选、检测等。",
      "learnMore": "了解更多",
      "subtitle": "亚科股份，全球医化材料的创新引领者。",
      "title": "关于亚科"
    },
    "globalService": {
      "description": "亚科股份能够为全球客户提供从定制合成到规模化生产的一站式CRO+CMO服务，满足您从科学研究到商业化生产的全流程产品需求。",
      "legend": {
        "customers": {
          "en": "Our Customers",
          "zh": "服务客户"
        },
        "headquarters": {
          "en": "Yacoo Headquarter",
          "zh": "亚科总部"
        },
        "subsidiaries": {
          "en": "Subsidiary Companies",
          "zh": "亚科子公司"
        }
      },
      "stats": {
        "title": "海外布局",
        "capacity": "新加坡，美国，德国均设立海外子公司",
        "patents": "全球客户数超15000家",
        "team": "业务覆盖全球70多个国家"
      },
      "title": "全球服务网络"
    },
    "news": {
      "noNews": "暂无相关新闻",
      "pageTitle": "资讯中心",
      "searchPlaceholder": "请输入关键字",
      "title": "亚科动态",
      "topTag": "置顶",
      "viewDetail": "了解详情",
      "viewMore": "查看更多"
    },
    "solutions": {
      "title": "产品与解决方案"
    }
  },
  "jcfw": {
    "businessIntroText1": "万德检测是亚科股份旗下的独立检测服务平台。基于亚科股份在医化材料领域22年的检测经验沉淀，万德检测致力于构建国际化的质量服务平台，依据CMA资质认定（中国计量认证）和CNAS实验室认可（ISO/IEC 17025）为国内/外的制造型企业/贸易公司提供各类(各国/各地区)法律/法规/技术规范的检测服务、认证及相应的咨询服务。为客户提供从检测到技术优化的一站式解决方案。",
    "businessIntroText2": "万德检测平台拥有3000㎡现代化实验室，已建成国内领先的空气循环与净化系统，确保检测环境安全可控。平台配备了完善的化学分析空间及全套高端仪器，满足高精度、高复杂度的检测需求。依据各国/地区法律法规及技术规范（如欧盟REACH、美国FDA、中国CDE等），协助客户规避贸易壁垒，实现产品全生命周期合规管理。",
    "businessIntroTitle": "业务概况",
    "businessItems": ["检验检测服务","医学研究和试验发展","检测技术服务","认证服务"],
    "businessItemsClass": ["日用消费品","电子电器产品","玩具及儿童用品","食品接触材料","汽车材料","轻工余货及纺织品"],
    "businessTip": "实验室已建立完善的检测服务体系，能够满足日用消费品、电子电器产品、玩具及儿童用品、食品接触材料、汽车材料、轻工余货及纺织品等的化学及物理检测需求。",
    "caseTabs": [{"title":"合规性检测认证经验","description":"实验室依托亚科股份在医化领域22年的检测服务经验，致力于为全球制造企业及贸易商提供合规检测、认证及技术咨询服务。"},{"title":"国际标准管理体系认证","description":"检测指标与管理体系符合国际质量体系要求，已获得众多国际头部客户认可，确保检测数据的权威性与公信力。"},{"title":"检测能力覆盖全面","description":"提供消费品化学检测、儿童玩具安全评估、纺织品检测、食品接触材料合规检测、汽车材料分析等领域的全面服务，助力企业应对各国法规要求（如REACH、FDA、CDE等）。"}],
    "contact": {
      "address": "地址：苏州工业园区新庆路112号 8层",
      "email": "联系邮箱：service@wondertesting.cn",
      "phone": "电话：18625246998",
      "postcode": "邮编：215121"
    },
    "contactTitle": "联系我们",
    "coreBusinessTitle": "核心业务",
    "equipmentDesc": "通过搭建完善的检测仪器平台，涵盖高效液相色谱仪、气相色谱仪、核磁共振谱仪、旋光测定仪、红外光谱仪等，亚科股份能够满足客户在各种影响场景下的高精度、高复杂度的放行检测需求。",
    "equipmentList": ["红外光谱仪","宽带多线圈核磁共振谱仪","电感耦合等离子体发射光谱仪","卡式库仑法水分仪","GC-MS","自动电位滴定仪"],
    "equipmentTitle": "检测设备",
    "featureTitle": "服务特色",
    "nextBtn": "下一个",
    "pageSubtitle": "独立检测到技术优化的集成服务商",
    "pageTitle": "检测服务",
    "platformDesc": "检测认证集成服务商",
    "prevBtn": "上一个",
    "shopSubtitle": "独立检测到技术优化的集成服务商",
    "shopTitle": "万德检测",
    "viewMore": "查看更多"
  },
  "kycg": {
    "businessIntroText": "元素商城(www.b2star.com)是亚科股份旗下专业的科研采购甄选电商平台。通过整合国内外优质品牌供应商渠道，提供专业的科研试剂、防护用品、生物耗材、实验设备等相关产品，致力于更好地满足国内外生命科学研究、生物医药及新材料等领域客户的多元化需求。",
    "businessIntroTitle": "业务概况",
    "businessItems": [{"title":"科研试剂","desc":"生物试剂，化学试剂，分析试剂，其他试剂"},{"title":"防护用品","desc":"手部防护，头部防护，面部防护，其他防护"},{"title":"生物耗材","desc":"细胞培养，医用耗材，色谱耗材，检测耗材，移液耗材，工具类耗材"},{"title":"实验设备","desc":"常规仪器，检测仪器，色谱仪器，专用仪器，安全设施"}],
    "caseTabs": [{"title":"24小时发货响应","description":"多仓直发，极速配送"},{"title":"600万+规格产品","description":"品牌众多，品类齐全"},{"title":"600+ 知名合作品牌","description":"厂家授权，正品保障"},{"title":"贴心的采购服务","description":"实惠多多，专业服务"}],
    "contact": {
      "addressSuqian": "地址(宿迁)：宿迁市宿豫区电商产业园谷客大厦(A9栋)一楼",
      "addressSuzhou": "地址(苏州)：苏州市工业园区新庆路112号",
      "addressWuhan": "地址(武汉)：武汉东湖新技术开发区高新大道766号光谷总部中心T3栋 11层07号",
      "addressChengdu": "地址(成都)：成都市武侯区武科西一路鼎盛国际3栋706室",
      "email": "邮箱：sxg@b2star.com",
      "phone": "电话：15335295587"
    },
    "contactTitle": "联系我们",
    "coreBusinessTitle": "核心业务",
    "enterShop": "进入订购",
    "featureTitle": "服务特色",
    "pageSubtitle": "科研采购甄选电商平台",
    "pageTitle": "科研甄选",
    "shopBusiness": ["科研试剂","安全防护","生物耗材","实验设备"],
    "shopSubtitle": "科研采购甄选电商平台",
    "shopTitle": "元素商城"
  },
  "lsny": {
    "businessIntroText": "古迪娜新能源（www.goodenoughchem.com）是亚科股份旗下绿色能源服务平台。自主研发的阻燃型原位固化剂，有效提高电池安全性，已获得诸多头部企业合作认可。作为新能源锂电材料集成服务商，古迪娜新能源能够满足您从科研需求到规模化生产的全方位需求，提供基础电解液的配置、电解液原材料以及特殊功能电解液、专业大量电解液配置/电解液定制服务。 ",
    "businessIntroTitle": "业务概况",
    "businessItems": [{"title": "电解液"},{"title": "化学试剂"},{"title": "电池材料"},{"title": "特殊功能电解液"}],
    "caseTabs": [{"title":"产品矩阵丰富","description":"已完成近百种新能源锂电功能添加剂的开发，可提供 锂/钠/镁/铝 电解液"},{"title":"研发定制到放大量产","description":"超10种锂电功能材料的产业化能力，其中乙氧磷腈系列产品规划产能百吨级"},{"title":"头部企业合作认可","description":"固体阻燃剂产品指标达到国际水平，获得国内众多头部新能源企业认可"}],
    "contactAddress": "地址：苏州工业园区新庆路112号 8层",
    "contactEmail": "邮箱：sales022@b2star.com",
    "contactPhone": "电话：18136447806",
    "contactPostcode": "邮编：215121",
    "contactQQ": "QQ：693755679",
    "contactSubtitle": "新能源锂电材料集成服务商",
    "contactTitle": "联系我们",
    "coreBusinessTitle": "核心业务",
    "enterShop": "了解更多",
    "featureTitle": "服务特色",
    "pageSubtitle": "新能源锂电材料集成服务商",
    "pageTitle": "绿色能源",
    "shopSubtitle": "新能源锂电材料集成服务商",
    "shopTitle": "古迪娜新能源"
  },
  "news": {
    "noNews": "暂无相关新闻",
    "pageTitle": "资讯中心",
    "searchPlaceholder": "请输入关键字",
    "title": "亚科动态",
    "topTag": "置顶",
    "viewDetail": "了解详情",
    "viewMore": "查看更多"
  },
  "products": {
    "centerTitle": "产品中心",
    "detail": {
      "advantages": "服务优势",
      "batchInquiry": "批量采购询价",
      "breadcrumbCenter": "产品中心",
      "breadcrumbHome": "首页",
      "cas": "CAS: {cas}",
      "customSynthesis": "定制合成咨询",
      "featured": "热销产品推荐",
      "features": "产品特色",
      "getSample": "获取样品",
      "noData": "暂无数据",
      "notes": "备注",
      "related": "相关产品推荐",
      "researchPurchase": "科研采购"
    },
    "mainProducts": "主要产品",
    "noData": "暂无数据",
    "searchBtn": "查询",
    "searchPlaceholder": "请输入品名、货号、CAS号或关键词",
    "panel": {
      "EnglishName": "英文名称",
      "Name": "品名",
      "Alias": "别名",
      "CAS": "CAS号",
      "UsagePlatform": "应用平台",
      "ArtNo": "货号",
      "molecularFormula": "分子式",
      "molecularWeight": "分子量",
      "ec": "EC号",
      "enzymeActivity": "酶活",
      "activity": "活性",
    }
  },
  "solution": {
    "learnMore": "了解更多",
    "pageSubtitle": "推动医化材料的技术进步与革新",
    "pageTip": "亚科股份始终专注于推动医化材料的技术进步与革新，基于技术创新和稳健供满足客户专业需求，提供优质、便捷、高性价比的多样化产品和服务，推动医化材料产业的持续进步，共建绿色健康未来。",
    "pageTitle": "行业解决方案",
    "tableName": "名称"
  },
  "sustainability": {
    "conceptText": "亚科股份始终秉持可持续发展理念，将绿色创新融入研发、生产与运营全流程。我们致力于通过环保工艺优化、资源循环利用及清洁能源应用，减少碳足迹；以科技创新推动可降解材料与绿色解决方案的开发，助力行业低碳转型。同时，我们积极践行社会责任，构建与员工、社区及环境的共生共赢体系，力求经济效益、生态效益与社会效益的协同发展，为全球可持续发展目标贡献力量。",
    "conceptTitle": "可持续发展理念",
    "dataSection": {
      "highConcentrationGas": "绿电用量占比",
      "lowConcentrationGas": "二氧化碳当量/百万元",
      "solidWasteStorage": "新疆克州二中图书捐赠",
      "wastewaterTreatment": "2024年社会公益捐款",
      "units": {
        "cubicMeterPerHour": "%",
        "ton": "吨",
        "tonPerDay": "册",
        "yuan": "元"
      }
    },
    "environmentalProtection": {
      "altText": "环境保护",
      "description": "亚科股份严格遵守国家和地方有关环境保护的相关法律法规以及其他有关规定，已通过ISO14001环境管理体系认证。具有完善的三废处理设施，通过引入先进的废水、废气和固废处理设施，能够在保证对环境友好的前提下安全开展生产活动。",
      "title": "环境保护"
    },
    "greenDevelopment": {
      "buildingAlt": "亚科股份总部大楼",
      "description": '秉承"超越医化边界，共创绿色未来"的企业初心，亚科股份无论在基础设施建设还是产品开发方面始终以绿色发展为己任。集团总部大楼荣获美国绿色建筑委员会颁发的LEED（能源与环境设计先锋）铂金级认证证书，通过太阳能板等绿电设备实现能源供给。亚科股份基于可再生的农作物生产的生物基新材料聚2，5-呋喃二甲酸乙二醇酯（PEF），能广泛应用在瓶片领域，显著减少产品生产过程中的整体碳足迹。',
      "title": "绿色发展"
    },
    "pageSubtitle": "医化产品CRO+CDMO定制服务",
    "pageTitle": "可持续发展",
    "safetyProduction": {
      "certificateAlt": "环境认证证书",
      "description": '亚科参照ISO45001职业健康安全管理体系要求，制定了完善的安全生产管理体系。通过信息化智能化设施，守护安全生命线。以亚科安庆生产基地为例，该基地获得生产安全标准化三级认证，建有安全生产信息化系统，实现了人员定位、智能巡检、双重预防等五位一体的安全风险防控体系。',
      "title": "安全生产"
    }
  },
  "technology": {
    "achievementsTitle": "创新成果",
    "businessIntroText": '亚科股份拥有超1万平方米的研发中心，配备AI合成平台、微通道连续流反应器等尖端设备，并组建了一支硕博士为核心的百余人的研发队伍。通过与中科院宁波材料所、苏州大学等高校的深度产学研合作，建立了“江苏省工程技术研究中心”“JITRI-亚科联合创新中心”等创新平台，形成完善的研发与成果转化体系。截至目前，企业已申请专利超过150件。',
    "businessIntroTitle": "完善的研发体系",
    "businessItems": [{"title":"生物医学净化剂和结构性化学品"},{"title":"高端体外诊断试剂开发"},{"title":"生物酶开发"},{"title":"高端生物聚合材料开发"},{"title":"半导体级电子化学品和新能源电池材料"}],
    "consultBtn": "定制咨询",
    "customServiceDesc": "基于医化材料领域22年的研发经验沉淀，亚科股份能够为客户提供可靠稳定的定制化合成服务。",
    "customServiceTitle": "从克级到吨级的定制化服务",
    "leadingProcess": "领先工艺",
    "pageTitle": "智驱科技 创想未来",
    "platformList": [{"title":"AI智能实验室","description":"AI智能合成安验室配备了AI智能合成仪可以自定义反应步骤和参数，对反应过程进行实时监控，可以实现工艺条件的快速筛选及最佳反应条件预测，提高研发效率。"},{"title":"高端试剂纯化实验室","description":"用作药辅级化学品和半导体级电子材料提纯。实验室配备先进的纯化设备，可对酸、醇、胺、腈类等化合物进行蒸馏、膜过滤提纯技术实验。"},{"title":"新能源电解质专用实验室平台","description":"平台可进行电解液阻燃剂和电解质实验。配备**设备，成功磷腈类助燃剂的研发工作。可根据客户电池的技术路径，持续开发液态、半液态电池材料。"},{"title":"生物合成绿色技术实验室平台","description":"生物合成在常温常压下进行，低能耗，不需要有机溶剂、减少或者不产生有毒副产品。该平台正在开发基于酶催化法合成生物缓冲剂产品、开发新诊断底物和高分子聚酯材料。"},{"title":"化学合成实验室平台","description":"化学合成实验室除了传统合成设备外，还配备核磁共振（NMR）、质谱、质谱（MS）、高效液相色谱（HPLC）、微通道连续流自动化合成工作站、实验室数据管理系统（LIMS）。 可完成药用辅料、诊断底物和高分子复合材料开发，包括客户定制开发。"}],
    "platformTitle": "五大智能化研发平台",
    "serviceIcons": ["生物医学净化剂和结构性化学品","高端体外诊断试剂开发","生物酶开发","高端生物聚合材料开发","半导体级电子化学品和新能源电池材料"],
    "starProduct": "创新产品"
  },
  "footer": {
    "contact": {
      "phone": "电话",
      "email": "邮箱"
    },
    "qrCode": {
      "scanToFollow": "扫码关注我们"
    },
    "socialMedia": {
      "wechat": "微信",
      "tiktok": "抖音",
      "xiaohongshu": "小红书"
    },
    "copyright": "© 2025 苏州亚科科技股份有限公司[苏ICP备15045967号]"
  },
  "croCdmoDialog": {
    "logoAlt": "亚科Logo",
    "hotline": "免费服务热线：",
    "description": "请留下您的需求信息，我们将在1个工作日内与您联系",
    "form": {
      "name": "姓名",
      "namePlaceholder": "请输入您的姓名",
      "contact": "联系方式",
      "contactPlaceholder": "请输入您的电话/手机号/邮箱",
      "company": "公司名称",
      "companyPlaceholder": "请输入您的公司名称",
      "product": "产品名称",
      "productPlaceholder": "请输入产品名称",
      "cas": "CAS号",
      "casPlaceholder": "请输入CAS号",
      "requirement": "采购需求",
      "requirementPlaceholder": "请输入您的采购需求",
      "attachment": "附件",
      "submit": "提交"
    },
    "upload": {
      "clickToUpload": "点击上传附件",
      "fileFormat": "文件格式：jpg、pdf、doc，文件大小不超过5M",
      "fileSizeError": "文件大小不能超过5M",
      "fileTypeError": "请上传jpg、pdf或doc格式的文件",
      "uploadSuccess": "文件上传成功",
      "uploadFailed": "文件上传失败，请重试"
    },
    "validation": {
      "nameRequired": "请输入姓名",
      "contactRequired": "请输入联系方式",
      "casRequired": "请输入CAS号"
    },
    "messages": {
      "submitSuccess": "提交成功",
      "submitFailed": "提交失败",
      "submitFailedRetry": "提交失败，请稍后重试"
    }
  },
  "productDialog": {
    "logoAlt": "亚科Logo",
    "hotline": "免费服务热线：",
    "description": "请留下您的需求信息，我们将在1个工作日内与您联系",
    "form": {
      "name": "姓名",
      "namePlaceholder": "请输入您的姓名",
      "contact": "联系方式",
      "contactPlaceholder": "请输入您的电话/手机号/邮箱",
      "company": "公司名称",
      "companyPlaceholder": "请输入您的公司名称",
      "product": "产品名称",
      "productPlaceholder": "请输入产品名称",
      "cas": "CAS号",
      "casPlaceholder": "请输入CAS号",
      "requirement": "采购需求",
      "requirementPlaceholder": "请输入您的采购需求",
      "submit": "提交"
    },
    "validation": {
      "nameRequired": "请输入姓名",
      "contactRequired": "请输入联系方式",
      "casRequired": "请输入CAS号"
    },
    "messages": {
      "submitSuccess": "提交成功",
      "submitFailed": "提交失败",
      "submitFailedRetry": "提交失败，请稍后重试"
    }
  },
  "serviceDialog": {
    "logoAlt": "亚科Logo",
    "hotline": "免费服务热线：",
    "description": "请留下您的需求信息，我们将在1个工作日内与您联系",
    "form": {
      "name": "姓名",
      "namePlaceholder": "请输入您的姓名",
      "contact": "联系方式",
      "contactPlaceholder": "请输入您的电话/手机号/邮箱",
      "company": "公司名称",
      "companyPlaceholder": "请输入您的公司名称",
      "service": "服务名称",
      "servicePlaceholder": "请输入服务名称",
      "requirement": "需求详述",
      "requirementPlaceholder": "请输入您的定制需求",
      "submit": "提交"
    },
    "validation": {
      "nameRequired": "请输入姓名",
      "contactRequired": "请输入联系方式"
    },
    "messages": {
      "submitSuccess": "提交成功",
      "submitFailed": "提交失败",
      "submitFailedRetry": "提交失败，请稍后重试"
    }
  },
  "purchaseDialog": {
    "logoAlt": "亚科Logo",
    "title": "更多品牌产品，尽在元素商城",
    "gotoStore": "前往商城查看",
    "storeInfo": "由亚科集团旗下元素商城提供服务"
  },
  "purchaseListDialog": {
    "logoAlt": "亚科Logo",
    "productInfo": "产品信息",
    "unitPrice": "单价（含税）",
    "more": "更多",
    "productCode": "商品编号：",
    "itemNumber": "货号：",
    "specification": "规格：",
    "parameter": "参数：",
    "contactSales": "联系销售询价",
    "gotoShop": "前往商城查看",
    "storeInfo": "由亚科集团旗下元素商城提供服务"
  },
"resumeDialog":{
  "logoAlt": "亚科",
    "upload": {
      "clickToUpload": "点击上传简历",
      "fileFormat": "文件格式：jpg、pdf、ppt，文件大小不超过5M",
      "fileSizeError": "文件大小不能超过5M",
      "fileTypeError": "请上传jpg、pdf或ppt格式的文件"
    },
    "fileInfo": {
      "removeFile": "删除文件"
    },
    "submit": "发送",
    "messages": {
      "uploadSuccess": "简历投递成功",
      "uploadFailed": "上传失败，请重试",
      "jobNotExist": "职位信息不存在",
      "pleaseUploadFirst": "请先上传简历"
    }
  },
  "goodChart": {
    "logoAlt": "亚科Logo",
    "companyName": "亚科股份",
    "consultationPhone": "咨询电话：",
    "productService": "产品咨询与售后服务：",
    "contactEmail": "联系邮箱：",
    "leaveMessage": "留言"
  },
  "searchPage": {
    "pageTitle": "全站搜索",
    "searchInfo": "搜索：{keyword}",
    "loading": "加载中...",
    "noData": "暂无数据",
    "noNews": "暂无相关新闻",
    "noProducts": "暂无相关产品",
    "productInfo": {
      "casNo": "CAS号：",
      "itemNumber": "货号：",
      "specification": "规格：",
      "parameter": "参数：",
      "price": "价格：",
      "unit": "单位：",
      "inquiry": "咨询",
      "chemicalName": "化学名称"
    },
    "newsInfo": {
      "typeTag": "类型标签"
    },
    "pagination": {
      "prev": "上一页",
      "next": "下一页"
    }
  }
};
